import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData } from 'shell/models/person';
import { transformPerson } from 'shell/utils/consult-person/response-transformer/person/person';
import { DeclarationCohabitationFormVM } from 'mutation/view-models/declaration-cohabitation';
import { DateTime } from 'luxon';

export const transformerDeclarationCohabitationData = (
  response: AxiosResponse<HttpResponse<ResponseAnprData>>
): DeclarationCohabitationFormVM => {
  const [person] = response.data?.payload?.risposta3002OK?.listaSoggetti.datiSoggetto || [];

  const personData = transformPerson(person);

  return {
    dichiarante: person,
    person: personData || undefined,
    editDataControl: {
      dateValidity: DateTime.now(),
    },
    cohabitationData: {
      file: null,
      municipality: null,
      list: '',
      notifyDate: null,
      professionist: '',
      requestDate: null,
      stipulationDate: null,
      notifyProtocol: '',
    },
    dataOrigineFamigliaConvivenza: person.famigliaConvivenza?.dataOrigineFamigliaConvivenza
      ? DateTime.fromISO(person.famigliaConvivenza.dataOrigineFamigliaConvivenza)
      : null,
    idFamilyIstat:
      person.famigliaConvivenza?.idFamigliaConvivenzaComune?.idFamigliaConvivenzaComuneIstat,
    idFamilyMunicipality:
      person.famigliaConvivenza?.idFamigliaConvivenzaComune?.idFamigliaConvivenza,
    idFamilyAnpr: person.famigliaConvivenza?.idFamigliaConvivenzaANPR,
  };
};
